module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-history"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Track History")]), _vm._v(" "), (_vm.playHistory && _vm.playHistory.length > 0 && _vm.loading == false) ? [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.playHistory), function(track, index) {
    return (index !== 0) ? _c('tr', {
      key: index
    }, [_c('td', [(track.artwork != null) ? [_c('img', {
      attrs: {
        "src": _vm._f("secure")(track.artwork),
        "alt": ((track.artist) + " - " + (track.track))
      }
    })] : [_c('img', {
      attrs: {
        "src": "//placehold.it/300x300?text=MR"
      }
    })]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getTimePlayed(track.timestamp)))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(track.artist))]), _vm._v(" "), (track.game) ? _c('span', {
      staticClass: "game"
    }, [_vm._v(_vm._s(track.game))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(track.track))]), _vm._v(" "), _c('td', {
      staticClass: "time"
    }, [(track.duration > 0) ? _c('span', [_vm._v(_vm._s(_vm.getTrackDuration(track.duration)))]) : _c('span', [_vm._v("N/A")])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('router-link', {
    staticClass: "load-more button is-primary",
    attrs: {
      "to": {
        path: ("/history/" + (this.page + 1))
      }
    }
  }, [_vm._v("Load more")])] : (_vm.loading == true) ? [_vm._m(1)] : [_c('h4', [_vm._v("There's nothing here!")])]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Time/Date")]), _vm._v(" "), _c('th', [_vm._v("Artist")]), _vm._v(" "), _c('th', [_vm._v("Track")]), _vm._v(" "), _c('th', {
    staticClass: "time"
  }, [_vm._v("Duration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" "), _c('span', [_vm._v("Fetching history, hang tight...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecea89e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HistoryView/index.vue
// module id = 279
// module chunks = 1